import React from 'react';
import { cn } from '@/utils/cn';

export interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Small element above the title, e.g. a "← Back" link. */
  back?: React.ReactNode;
  /** Right-aligned primary actions (one primary <Button> at most). */
  actions?: React.ReactNode;
  /** Optional row under the title: search, filters, tabs. */
  toolbar?: React.ReactNode;
  className?: string;
}

/** The one page title block for admin / settings pages: h2 title, muted subtitle, actions on the right. */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, back, actions, toolbar, className }) => (
  <div className={cn('space-y-3', className)}>
    {back}
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-h2 text-ui-text">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-ui-text2">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
    {toolbar}
  </div>
);

export default PageHeader;
